export default {
  // 后台人员登录
  'admin-auth': {
    uri: 'admin/auth',
    auth: false,
  },
  // 获取公众号签名
  'wechat.signature': {
    uri: 'wechat/jsapi-signature',
    auth: false,
  },
  // 微信获取access_token
  'wechat.access_token': {
    uri: 'wechat/:appid/token',
    auth: false,
  },
  // 微信小程序获取URLScheme
  'wechat.URLScheme': {
    uri: 'wechat/generateScheme',
    auth: false,
  },
  // 微信
  'wechat.oauth2': {
    uri: 'wechat/oauth2',
    auth: false,
  },
  // 接待微信
  'weixins.service': {
    uri: 'weixins/service',
    auth: false,
  },
  // 弹框微信加好友
  'weixins.index': {
    uri: 'weixins/:id',
    auth: false,
  },
  'weixins.view': {
    uri: 'weixins/:id',
    auth: false,
  },
  // 反馈详情
  advice: {
    uri: 'advices/:id',
    auth: 'required',
  },
  // 纠错详情
  corrections: {
    uri: 'corrections/:id',
    auth: 'required',
  },
  // 图片
  'file.view': {
    uri: 'files/:id',
    auth: false,
  },
  files: {
    uri: 'files',
    auth: 'required',
  },
  // 视频
  'video.view': {
    uri: 'videos/:id',
    auth: false,
  },
  // 获取视频播放信息
  'videos.view': {
    uri: 'videos/:id',
    auth: 'optional',
  },
  // 文章
  article: {
    uri: 'articles',
    auth: false,
  },
  'article-category': {
    uri: 'article-categories',
    auth: false,
  },
  'article.view': {
    uri: 'articles/:id',
    auth: false,
  },
  // 课程列表
  courses: {
    uri: 'courses',
    auth: false,
  },
  // 智能搜索
  elasticsearch: {
    uri: 'so',
    auth: false,
  },
  'course.index': {
    uri: 'courses',
    auth: 'optional',
  },
  'course.view': {
    uri: 'courses/:id',
    auth: 'optional',
  },
  'course.chapters': {
    uri: 'courses/:id/chapters',
    auth: 'optional',
  },
  // 更新历史观看记录
  'course-section.watch': {
    uri: 'course-sections/:id/watch',
    auth: 'required',
  },
  // 分类
  'category.index': {
    uri: 'categories',
    auth: false,
  },
  'category.view': {
    uri: 'categories/:id',
    auth: false,
  },
  // 商品列表
  'category.products': {
    uri: 'categories/:id/products',
    auth: false,
  },
  // 二级分类下套餐的全科数量
  'category.meta': {
    uri: 'category-meta',
    auth: false,
  },
  // 商品规格
  'product.specs': {
    uri: 'products/:id/specs',
    auth: false,
  },
  // 套餐列表
  products: {
    uri: 'products',
    auth: 'false',
  },
  // 套餐详情
  'product.view': {
    uri: 'products/:id',
    auth: 'false',
  },
  'major-subject.index': {
    uri: 'major-subjects',
    auth: false,
  },
  // 文档
  'document.index': {
    uri: 'documents',
    auth: false,
  },
  'document.view': {
    uri: 'documents/:id',
    auth: 'optional',
  },
  'document.update': {
    uri: 'documents/:id',
    auth: false,
  },
  // 优惠券详情
  'coupon-stock.view': {
    uri: 'coupon-stocks/:id',
    auth: false,
  },
  // 领取优惠券
  'coupon.create': {
    uri: 'coupon-stocks/:id/coupons',
    auth: 'required',
  },
  // 用户
  // 可查询用户信息&&更新用户信息
  'user.view': {
    uri: 'users/:id',
    auth: 'required',
  },
  // 更新用户
  'user.index': {
    uri: 'users/:id',
    auth: 'required',
  },
  // 账号绑定(绑定openid)
  'create-auth': {
    uri: 'users/:id/create-auth',
    auth: 'required',
  },
  'user.enrollment': {
    uri: 'users/:id/enrollment',
    auth: 'required',
  },
  // 协议
  'user.ongoing-contract': {
    uri: 'users/:id/ongoing-contract',
    auth: 'required',
  },
  // 优惠券
  'user.coupons': {
    uri: 'users/:id/coupons',
    auth: 'required',
  },
  // 学习卡
  'user.learnCard': {
    uri: 'users/:id/learn-cards',
    auth: 'required',
  },
  check: {
    uri: 'check',
    auth: false,
  },
  'check-block': {
    uri: 'check-block',
    auth: false,
  },
  reg: {
    uri: 'reg',
    auth: false,
  },
  auth: {
    uri: 'auth',
    auth: false,
  },
  wxreg: {
    uri: 'wxreg',
    auth: false,
  },
  //协议
  'user-contract': {
    uri: 'user-contracts/:number',
    auth: false,
  },
  'user-contract.signment': {
    uri: 'user-contracts/:id/signment',
    auth: 'required',
  },
  'user-contract.handsign': {
    uri: 'user-contracts/:id/hand-sign',
    auth: 'required',
  },
  // 协议支付
  'user-contract.payment': {
    uri: 'user-contracts/:id/payment',
    auth: 'required',
  },
  'user-contract.view': {
    uri: 'user-contracts/:id',
    auth: 'required',
  },
  'user-contract.unified-order': {
    uri: 'user-contracts/:id/unified-order',
    auth: 'required'
  },
  'user-contract.svip': {
    uri: 'user-contracts/svip-sign',
    auth: 'required'
  },
  // 工具
  'tool.sms-sender': {
    uri: 'tool/sms-sender',
    auth: false,
  },
  'tool.tts-sender': {
    uri: 'tool/tts-sender',
    auth: false,
  },
  'captcha-generator': {
    uri: 'captcha/generator',
    auth: false,
  },
  // 规则
  rules: {
    uri: 'categories/:id/rules',
    auth: false,
  },
  // 题库
  'exam.paper-categories': {
    uri: 'exams/:id/paper-categories',
    auth: false,
  },
  'exam.index': {
    uri: 'exams',
    auth: 'optional',
  },
  'queryPhone': {
    uri: 'users/:id/auths',
    auth: 'required',
  },
  'activated-contracts': {
    uri: 'activated-contracts',
    auth: 'required',
  },
  'exam-date': {
    uri: 'categories/:id/exam-date',
    auth: false,
  },
  // 题库列表
  'paper-category.papers': {
    uri: 'paper-categories/:id/papers',
    auth: false,
  },
  'queryByPapers': {
    uri: 'papers/:id/tests',
    auth: false
  },
  'queryByPaper': {
    uri: 'tests/:id',
    auth: false
  },
  'lecturers': {
    uri: 'lecturers',
    auth: 'false'
  },
  'lecturers.view': {
    uri: 'lecturers/:id',
    auth: 'false'
  },
  'by-area': {
    uri: 'articles/list-by-area',
    auth: false,
  },
  'copie.view': {
    uri: 'copies/:id',
    auth: false,
  },
  coupons: {
    uri: 'coupons',
    auth: 'required',
  },
  'coupons.view': {
    uri: 'coupons/:id',
    auth: false,
  },
  // 政策条款
  policies: {
    uri: 'policies',
    auth: false,
  },
  activities: {
    uri: 'activities/:name',
    auth: false,
  },
  'company.view': {
    uri: 'companies/:id',
    auth: 'required',
  },
  // 分校
  'online-account.appid': {
    uri: 'online-accounts/appid',
    auth: 'required',
  },
  'user-order.view': {
    uri: 'user-orders/:id',
    auth: 'required',
  },
  
  // 规格
  'user.products': {
    uri: 'users/:id/products',
    auth: 'required',
  },
  // 广告列表
  'ad.index': {
    uri: 'ads',
    auth: false,
  },
  // 更新广告点击次数
  'ad.update': {
    uri: 'ads/:id',
  },
  // 银行列表接口
  'bank.accounts': {
    uri: 'companies/:id/bank-accounts',
  },
  // 线下支付表单提交接口
  'offline.payment': {
    uri: 'user-contracts/:id/offline-payment',
    auth: 'required',
  },
  // 检查线下支付是否成功
  'apply.record': {
    uri: 'user-contracts/:id/apply-record',
    auth: 'required',
  },
  // 协议附件删除接口
  'delete.attachment': {
    uri: 'user-contracts/:id/delete-attachment',
    auth: 'required',
  },
  'livecourse.sign': {
    uri: 'live-courses/:id/sign',
    auth: 'required'
  },
  'interview.surveyed': {
    uri: 'interviews/:id/surveyed',
    auth: false,
  },
  'interview.vita': {
    uri: 'interviews/:id/vita',
    auth: false,
  },
  'interview.view': {
    uri: 'interviews/:id',
    auth: false,
  },
  'interview.remove': {
    uri: 'interviews/:id/remove',
    auth: false
  },
  'interview.questionnaires': {
    uri: 'interviews/:id/questionnaires',
    auth: false,
  },
  'kefu': {
    uri: 'customer-service',
    auth: false,
  },
  'reservation.user': {
    uri: 'reservation-users/:id',
    auth: false
  },
  'transfer': {
    uri: 'reward-records/:id/wechat-transfer-package',
    auth: false
  },
  'bind-openid': {
    uri: '/wechat/openid/bind',
    auth: false,
  },
  'app-config': {
    uri: '/app/config',
    auth: false,
  },
  'product.contract-preview': {
    uri: '/products/:id/contract-preview',
    auth: false,
  },
  'online-paper': {
    uri: '/online-mocks/pcats/:id/paper',
    auth: 'required',
  },
  'exam.entry': {
    uri: '/online-mocks/exams/:id/entry',
    auth: 'required',
  },
};
